import logo from './logo.svg';
import './App.css';
import { BrowserRouter, Routes, Route, useNavigate,Navigate } from 'react-router-dom'
import Login from './Pages/Login' 
import Home from './Pages/Home'
import SingleVideo from './Pages/SignleVideo' 
import HomeVideo from './Pages/HomeVideo' 
import Otp from './Pages/Otp';
import GetHeaders from './Pages/GetHeaders';
import Welcome from './Pages/Welcome';
import TermsPage from './Pages/TermsPage';
import { ToastContainer } from 'react-toastify';
 import 'react-toastify/dist/ReactToastify.css';



function App() {
  return (
    <>
          <ToastContainer />

       <Routes>
          <Route path='/welcome' element={<Welcome/>} />
          <Route path='/header' element={<GetHeaders/>} />
          <Route path='/subscribe' element={<Login serviceName='MadFunny'/>} />
          <Route path='/redirect' element={<Home />} />
          <Route path='/video/:id/:service/:mid' element={<SingleVideo />} />
          <Route path='/otp-validation' element={<Otp serviceName='MadFunny'/>} />
          <Route path='/allvideos/:id/:service/:count' element={<HomeVideo />} />
          <Route path='/allvideos/:id/:service' element={<HomeVideo />} />
          <Route path='/tnc' element={<TermsPage/>} />

          <Route path="*" element={<Navigate to="/welcome" />} />
        </Routes>
    </>
  );
}

export default App;
